import Chart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import { FC, useMemo, useState } from 'react';
import { Select } from './ui/select';
import SelectForm from './ui/SelectForm';
import useGetUserAnalytics from '@/hooks/useGetUserAnalytics';

type Props = {
  title?: string;
  defaultRange?: string;
};

const NewUsersChart: FC<Props> = ({
  title = 'New Users',
  defaultRange = '7d',
}) => {
  const [selectedRange, setSelectedRange] = useState<string>(defaultRange);

  const { data: userAnalytics } = useGetUserAnalytics(selectedRange);

  const chartOptions: ApexOptions = {
    chart: {
      type: 'area',
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    stroke: {
      curve: 'smooth',
      width: 3,
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: userAnalytics?.categories,
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        formatter: (value) => `${Math.floor(value)}`,
      },
    },
    grid: {
      strokeDashArray: 4,
    },
    tooltip: {
      y: {
        formatter: (value) => `${value} users`,
      },
    },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.4,
        opacityTo: 0.05,
        stops: [0, 90, 100],
      },
    },
    legend: {
      show: false,
    },
  };

  const chartSeries = [
    {
      name: 'New Users',
      data: userAnalytics?.series,
    },
  ];

  return (
    <div className="w-full rounded-lg border bg-white p-4 shadow-sm">
      <div className="mb-4 flex items-center justify-between gap-3">
        <h2 className="text-lg font-semibold">{title}</h2>
        <div>
          <SelectForm
            items={[
              { label: 'Last 7 days', value: '7d' },
              { label: 'Last 30 days', value: '30d' },
              { label: 'Last 90 days', value: '90d' },
            ]}
            defaultValue={selectedRange}
            onChange={(value) => setSelectedRange(value)}
          />
        </div>
      </div>

      <Chart
        options={chartOptions}
        series={chartSeries}
        type="area"
        height={320}
      />
    </div>
  );
};

export default NewUsersChart;
